import { defineMessages } from 'react-intl';

export default defineMessages({
  collateralSeized: { defaultMessage: 'Collateral seized' },
});
